
<template src="./MapLegend.html"> </template>

<script>

import { mapActions, mapState } from 'vuex';

export default {
    name: "MapLegend",
    props: {
        variable: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: false
        },
        map: { // map1 or map2
            type: String,
            required: true
        }
    },

    data() {
        return {
            notAvailableLegends: ['thiDev', 'thiHis', 'thi', 'chillHHis', 'chillHDev', 'lwtDev', 'lwtHis']
        }
    },

    methods: {
        
        ...mapActions({
            getLegend: 'getLegend'
        }),

        getMapLegend() {
            
            if (this.variable != '') {
                if (this.mapLegend[this.map].layer != this.variable) {
                    if (this.notAvailableLegends.indexOf(this.variable) == -1)
                        this.getLegend({variable: this.variable, map: this.map});
                }
            }
        }
    },

    computed: {

        ...mapState({
            mapLegend: 'mapLegend'
        }),

        legend() {
           
            //let l = "linear-gradient(90deg,#008001,#169B1E,#2BAB27,#00ff83,#00ff36,#8aff00,#b0ff00,#d7ff00,#fdff00,#FFe600,#FFd200,#FFaa00,#FF6e00,#FE235A,#DE0138,#CA1531,#800000";
            //let legend = "linear-gradient(90deg,#FCEECA,#EA4D00,#FF6A22,#FC8501,#FEB563,#FFCD20,#FFE179,#E2FF7D,#C7FF06,#A5FE43,#00ffa8,#00ffd0,#00e4ff,#00c4ff,#00a4ff,#0084ff,#0064ff,#0100ff,#001ACC,#8A2BFF,#A400EA,#9400A4,#C700DD,#FE01D1,#FF1A98,#FE527D,#FE235A,#DE0138,#CA1531)";

            this.getMapLegend();

            if (this.mapLegend[this.map].values.length == 0) return;
            
            var colors = this.mapLegend[this.map].colors;
            var ls = [];

            for(let i = 0; i < colors.length; i++) {
                var fcolor = colors[i+1];

                if (fcolor == undefined)
                    fcolor = colors[i];

                ls.push(
                    'linear-gradient(90deg,' + colors[i] + ',' + fcolor + ')'
                )
                // console.log(colors[i], fcolor);
            }

            return ls;

            // if (this.mapLegend[this.map].values.length == 0) return;

            // let l = 'linear-gradient(90deg,';
            // this.mapLegend[this.map].colors.forEach(color => {
            //     l += color;
            //     l += ',';
            // });
            // l = l.slice(0, -1); // Remove last comma
            // l += ')';
            
            // return l;
        },

        legendValues() {
            //let values = [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0];
            // console.log('length: ', length, ' - ', Math.round(length/4) , ' ', Math.round(length/2), ' ', Math.round(length/4) + Math.round(length/2), ' ', length)
            if (this.mapLegend[this.map].values.length == 0) return;

            let values = this.mapLegend[this.map].values;
            //let length = values.length - 1;

            //values = [values[0], values[Math.round(length/4)], values[Math.round(length/2)], values[Math.round(length/4) + Math.round(length/2)], values[length]];
            return values;
        },      
    },

    mounted() {

    },

}
</script>

<style lang="scss" src="./MapLegend.scss"> </style>